var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { find } from 'lodash';
import { Select } from '../select';

var OptionsArraySelect = function (_super) {
  __extends(OptionsArraySelect, _super);

  function OptionsArraySelect() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OptionsArraySelect.prototype.render = function () {
    var _a = this.props,
        _onChange = _a.onChange,
        value = _a.value,
        options = _a.options;
    var control = Object.assign({}, this.props, {
      mode: 'multiple',
      value: value ? value.map(function (_a) {
        var id = _a.id;
        return id;
      }) : null,
      onChange: function onChange(value, name) {
        _onChange(value.map(function (id) {
          return find(options, {
            id: id
          });
        }), name);
      }
    });
    return React.createElement(Select, __assign({}, control));
  };

  return OptionsArraySelect;
}(Component);

export { OptionsArraySelect };